import { useQuery } from '@tanstack/react-query';
import { listUserInvoices, type UserInvoiceFilters } from '../lib/userInvoicesApi';

// Unified per-user invoices query (CLE-238). Keyed by userId + filters so
// pagination/filtering refetches cleanly; placeholderData keeps the previous
// page visible while the next loads.
export function useUserInvoices(userId: string | undefined, filters: UserInvoiceFilters = {}) {
  return useQuery({
    queryKey: ['userInvoices', userId, filters],
    queryFn: () => listUserInvoices(userId as string, filters),
    enabled: Boolean(userId),
    placeholderData: (prev) => prev,
  });
}
